// Static content for Lumiqo landing page
import {
  Film,
  LayoutGrid,
  ImageIcon,
  Cpu,
  Target,
  Wand2,
  TrendingUp,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const CLIENT_STRIP = [
  "Instagram",
  "YouTube",
  "TikTok",
  "Real Estate",
  "Education",
  "E-Commerce",
  "Coaches",
  "Podcasts",
  "Fitness",
  "SaaS Founders",
];

export const SERVICES = [
  {
    icon: Film,
    title: "Video Editing",
    desc: "We edit three types of videos — Talking Head, Real Estate and Educational — cut to retain attention from frame one.",
    tag: "Reels · YT · Ads",
    details: [
      {
        name: "Talking Head Videos",
        note: "Founder stories, coaching content & personal brands",
      },
      {
        name: "Real Estate Videos",
        note: "Luxury walkthroughs, listings & property reels",
      },
      {
        name: "Educational Videos",
        note: "Courses, explainers & value-packed content",
      },
    ],
  },
  {
    icon: LayoutGrid,
    title: "Social Media Management",
    desc: "Your entire social presence, handled end to end.",
    tag: "End-to-end",
    details: [
      {
        name: "Content Research",
        note: "Trend & niche research to find what actually works",
      },
      {
        name: "Script Writing",
        note: "High-converting short-form scripts — hooks, retention, CTA",
      },
      {
        name: "Full Platform Management",
        note: "Strategy, posting, engagement and analytics",
      },
    ],
  },
  {
    icon: ImageIcon,
    title: "Thumbnail & Cover Design",
    desc: "Click-worthy covers built to win the algorithm — from reels to podcasts.",
    tag: "YT · Reels · Podcasts",
    details: [
      { name: "Reel Cover", note: "Scroll-stopping covers for Instagram reels" },
      {
        name: "Educational Reel Cover",
        note: "Clean, curiosity-driven covers for value content",
      },
      {
        name: "YouTube Thumbnail",
        note: "High-CTR thumbnails engineered for the algorithm",
      },
      { name: "Podcast Cover", note: "Premium cover art for podcast episodes" },
    ],
  },
  {
    icon: Cpu,
    title: "AI Automation",
    desc: "Smart AI workflows that scale your content and your leads.",
    tag: "Workflows",
    details: [
      {
        name: "AI-Powered Video Production",
        note: "10x your content output without sacrificing brand voice",
      },
      {
        name: "AI Lead Scraping",
        note: "Generate & find qualified leads automatically using AI",
      },
      {
        name: "AI Voice Cloning for Videos",
        note: "A consistent brand voice across every video",
      },
      {
        name: "AI Lead Qualification Agent",
        note: "When a lead messages, AI qualifies them and sends the details straight to your email",
      },
    ],
  },
];

export const PROCESS = [
  {
    icon: Target,
    title: "Share Your Goals",
    desc: "Hop on a free call. We map your brand, audience and the outcomes you actually care about.",
    step: "01",
  },
  {
    icon: Wand2,
    title: "We Create & Deliver",
    desc: "Our editors, designers and strategists ship scroll-stopping content on a weekly cadence.",
    step: "02",
  },
  {
    icon: TrendingUp,
    title: "You Grow & Scale",
    desc: "Watch views, leads and revenue compound while you focus on your zone of genius.",
    step: "03",
  },
];

// Portfolio filters — only categories with real content remain.
export const PORTFOLIO_FILTERS = ["All", "Real Estate", "Talking Head"];

/**
 * PORTFOLIO entries.
 * - `src`     → direct Cloudinary MP4, plays in a native <video> in the lightbox.
 * - `driveId` → legacy Google Drive preview iframe (still supported).
 */
export const PORTFOLIO = [
  // Real Estate (4 videos — exact user-specified order)
  {
    title: "Luxury Walkthrough · 01",
    category: "Real Estate",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784213308/52_Roxborough_DriveA_rare_fully_reimagined_estate_in_the_heart_of_North_Rosedale.128_feet_of_fr_ejcnfi.mp4",
  },
  {
    title: "Premium Listing · 02",
    category: "Real Estate",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784213343/New_listing_in_Bloomfield_Who_s_ready_to_move_in_and_call_it_home_Agent_in_video-_michigan_wcix2r.mp4",
  },
  {
    title: "Estate Tour · 03",
    category: "Real Estate",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784213422/Turning_listings_into_scroll-stopping_moments_Our_cinematic_4K_listing_videos_are_designed_t_eemly2.mp4",
  },
  {
    title: "Penthouse Reel · 04",
    category: "Real Estate",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784213783/NEW_LISTING_in_LA_JOLLA_3_BD_-_2_BA_-_2_027_SQFT_La_Jolla_CA_2_999_900Perfectly_positione_vzintc.mp4",
  },

  // Talking Head (4 videos — exact user-specified order)
  {
    title: "Founder Spotlight · 01",
    category: "Talking Head",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784212591/saloni1F_1_jnvqsh.mp4",
  },
  {
    title: "Coach Story · 02",
    category: "Talking Head",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784212851/AQOGYu2GqsEo8AYjDK3WWPYsoNIl5q-t5M_TL5ZAxhJqTOto6TgzSgli9bh3qvTdRFCQsuXbxlwyRwS47ryM6oivJ8tYyFvi_kuuyng.mp4",
  },
  {
    title: "Expert Take · 03",
    category: "Talking Head",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784213062/Book_a_call_with_us_today_at-_www.biharimotions.in_contentcreation_contentmarketing_graphicdes_wmxv3i.mp4",
  },
  {
    title: "Creator Insight · 04",
    category: "Talking Head",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1784213166/From_Klickpin.com-_Try_this_guide_to_clever_engagement_party_ideas_perfect_for_saving_sharing_and_recreating_later_that_balance_trend_comfort_and_dzf6z2.mp4",
  },
  {
    title: "Brand Voice · 05",
    category: "Talking Head",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1787560073/FINAL_1_1_wukfdx.mp4",
  },
  {
    title: "Personal Brand · 06",
    category: "Talking Head",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1787560082/B_12_udtgkk.mp4",
  },
  {
    title: "Storyteller Cut · 07",
    category: "Talking Head",
    type: "video",
    src: "https://res.cloudinary.com/owzt7ro1/video/upload/v1787560093/FINAL_2_lmktn0.mp4",
  },
];

// Derive a first-frame poster image from a Cloudinary video URL (card thumbnails only;
// playback always uses the untouched `src`).
export const cloudinaryPoster = (src) =>
  src
    .replace("/video/upload/", "/video/upload/so_0,w_800,c_limit,q_auto,f_jpg/")
    .replace(/\.mp4$/, ".jpg");

// 5 real reel covers (Google Drive images, 9:16)
export const REEL_COVERS = [
  { driveId: "1o07sRngqv7BG_ocyZSKxatDh7m5t5iTQ", title: "Reel Cover · 01" },
  { driveId: "1g1Ova9GwkdA9IS5k42j2UNwk4fvzYTbD", title: "Reel Cover · 02" },
  { driveId: "1o4Z13y6AfilRL84YU-LNXrxB_ABCA847", title: "Reel Cover · 03" },
  { driveId: "1dha7WFC8dgTp-jT19HepoZNOzkRK3t8X", title: "Reel Cover · 04" },
  { driveId: "1Ops1uLcCSmU5W-63y83frKVrcKzj-BI4", title: "Reel Cover · 05" },
];

// 6 real YouTube thumbnails (Google Drive images, 16:9)
export const YOUTUBE_THUMBNAILS = [
  { driveId: "1eWbhfmd98b2T3JXsJSw_ycTvW8Ef5Xiw", title: "YouTube Thumbnail · 01" },
  { driveId: "1p-7Gy389jBD_aQYDZMXQNFXbq2cgidDU", title: "YouTube Thumbnail · 02" },
  { driveId: "1XHrgxesGd-iMnk4qWJtxO4KK4UvCvU8J", title: "YouTube Thumbnail · 03" },
  { driveId: "1-K6F5WIT0VEbFtGSoJBZLoMDp-QNnkAj", title: "YouTube Thumbnail · 04" },
  { driveId: "1EUVOmZ-h9DF0SdQxWpUB0BWqfvxDKJfe", title: "YouTube Thumbnail · 05" },
  { driveId: "14oXvae84iBTvFYggAmS0pgBUNSnvLhDF", title: "YouTube Thumbnail · 06" },
];

export const STATS = [
  { value: 50, suffix: "+", label: "Clients Served" },
  { value: 500, suffix: "+", label: "Videos Edited" },
  { value: 10, suffix: "M+", label: "Views Generated" },
  { value: 98, suffix: "%", label: "Client Retention" },
];

export const TESTIMONIALS = [
  {
    name: "Aarav Mehta",
    role: "Real Estate Founder · Mumbai",
    quote:
      "Lumiqo turned our listing reels into a lead machine. We booked 3 luxury walkthroughs in the first 14 days.",
    rating: 5,
    photo:
      "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
  },
  {
    name: "Sofia Romano",
    role: "Mindset Coach · 220K IG",
    quote:
      "The visual hooks alone tripled my reach. Their editors get short-form better than anyone I’ve worked with.",
    rating: 5,
    photo:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
  },
  {
    name: "Priya Sharma",
    role: "Content Creator · Bangalore",
    quote:
      "My reels jumped from 8K to 150K average views in six weeks. Their hooks and pacing are genuinely on another level.",
    rating: 5,
    photo:
      "https://images.unsplash.com/photo-1627161683077-e34782c24d81?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
  },
  {
    name: "Rohan Verma",
    role: "Founder · Delhi",
    quote:
      "Lumiqo rebuilt our whole content engine. 2x engagement and 40+ inbound leads in the first month alone.",
    rating: 5,
    photo:
      "https://images.unsplash.com/photo-1623605931891-d5b95ee98459?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
  },
  {
    name: "Lukas Werner",
    role: "YouTuber · 480K subs",
    quote:
      "From script to upload, they own the whole pipeline. Best decision I made for the channel this year.",
    rating: 5,
    photo:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
  },
];

// Hero "trusted by 50+ creators & brands" — 4 real LinkedIn-style headshots.
export const HERO_AVATARS = [
  {
    src: "https://images.unsplash.com/photo-1618077360395-f3068be8e001?w=160&h=160&fit=crop&crop=faces&auto=format&q=80",
    alt: "Founder profile",
  },
  {
    src: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=160&h=160&fit=crop&crop=faces&auto=format&q=80",
    alt: "Creator profile",
  },
  {
    src: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=160&h=160&fit=crop&crop=faces&auto=format&q=80",
    alt: "Marketer profile",
  },
  {
    src: "https://images.unsplash.com/photo-1610631066894-62452ccb927c?w=160&h=160&fit=crop&crop=faces&auto=format&q=80",
    alt: "Business owner profile",
  },
];

export const PRICING = {
  monthly: [
    {
      name: "Starter",
      price: "$148",
      period: "/month",
      tagline: "Test the waters with premium editing.",
      features: [
        "5 Reels edited per month",
        "Captions & sound design",
        "1 round of revisions",
        "48h average delivery",
        "Dedicated editor",
      ],
      cta: "Start with Starter",
      highlight: false,
    },
    {
      name: "Growth",
      price: "$558",
      period: "/month",
      tagline: "Most loved by creators scaling fast.",
      features: [
        "15 Reels edited per month",
        "Viral hook edits included",
        "Thumbnail design (4/mo)",
        "Hook & script consult",
        "Priority 24h turnarounds",
        "2 rounds of revisions",
      ],
      cta: "Start growing",
      highlight: true,
    },
    {
      name: "Agency",
      price: "$1,500",
      period: "/month",
      tagline: "Full social media operations — A to Z.",
      features: [
        "Full social media management",
        "Reels + Thumbnails + Posting",
        "Script writing & strategy",
        "AI automation workflows",
        "Weekly performance reports",
        "Unlimited revisions",
      ],
      cta: "Book agency call",
      highlight: false,
    },
  ],
  project: [
    {
      name: "Single Reel",
      price: "$45",
      period: "/reel",
      tagline: "Need a one-off banger? We got you.",
      features: [
        "1 fully edited reel",
        "Captions + sound design",
        "1 round of revisions",
        "48h delivery",
      ],
      cta: "Order a reel",
      highlight: false,
    },
    {
      name: "Content Sprint",
      price: "$480",
      period: "/sprint",
      tagline: "2-week creative sprint to ignite the channel.",
      features: [
        "12 reels in 14 days",
        "Hook edits + thumbnails",
        "Hook bank & script consult",
        "Priority turnaround",
        "Strategy debrief",
      ],
      cta: "Book a sprint",
      highlight: true,
    },
    {
      name: "Launch Package",
      price: "$1,800",
      period: "/launch",
      tagline: "Brand or product launch, fully handled.",
      features: [
        "Launch strategy + scripts",
        "30 pieces of content",
        "Thumbnails, covers, ads",
        "Posting + engagement",
        "Post-launch report",
      ],
      cta: "Plan my launch",
      highlight: false,
    },
  ],
};

export const SOCIAL_LINKS = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/lumiqo-media-a4660833b?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    icon: "linkedin",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/lumiq_o?igsh=OTJsa2Vjd3g5am56",
    icon: "instagram",
  },
  { label: "X", href: "https://x.com/lumiqomedia", icon: "x" },
];

/* ---------- Business / About info ---------- */
export const BUSINESS = {
  name: "Lumiqo",
  tagline: "Turning Brands Into Viral Machines.",
  about:
    "Lumiqo is a premium video editing and social media growth studio crafting scroll-stopping content for creators, real estate brands and modern businesses. Every cut, cover and caption is engineered for attention, retention and reach.",
  location: "Muzaffarpur, Bihar, India",
  email: "lumiqomedia@gmail.com",
  phone: "+91 91172 11085",
  phoneRaw: "+919117211085",
};

/* ---------- Google Drive helpers ---------- */
export const driveThumb = (id, w = 1000) =>
  `https://drive.google.com/thumbnail?id=${id}&sz=w${w}`;

export const drivePreview = (id) =>
  `https://drive.google.com/file/d/${id}/preview`;
